import React, { useContext, useEffect, useRef } from "react";
import styles from "./StickyGallery.module.scss";
import StickyContext from "../../context/sticky";
const StickyGallery = (props) => {
  const progress = useContext(StickyContext);
  const refInner = useRef(null);
  const refBody = useRef(null);
  useEffect(() => {
    const inner = refInner.current;
    const body = refBody.current;
    let innerWidth = inner.offsetWidth;
    let bodyWidth = body.offsetWidth;
    let left = (innerWidth - bodyWidth) * progress / 100;
    inner.style.left = -left + 'px';
    
    // console.log(progress);
  }, [progress]);
  return (
    <>
      <div className={styles.wrap}>
          <div className={styles.body} ref={refBody}  data-animate={'fade-in-left'}>
            <div className={styles.inner} ref={refInner}>
              {props.children}
              
            </div>
          </div>
      </div>
    </>
  );

}

export default StickyGallery;
